export default "__VITE_ASSET__Dk3FjRoe__"